webpackJsonp([94373142159810],{

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(73);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Loader = __webpack_require__(75);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Quotes = function (_Component) {
	  _inherits(Quotes, _Component);
	
	  function Quotes(props) {
	    _classCallCheck(this, Quotes);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      _axios2.default.get('https://wt-566da441a4b59d2631369d6ab2777d69-0.sandbox.auth0-extend.com/randomeQuote').then(function (res) {
	        var data = res.data;
	
	        _this.setState({
	          author: data[0].author,
	          quote: data[0].body,
	          loading: false
	        });
	      }).catch(function (error) {
	        _this.setState({
	          loading: false,
	          error: 'there is an error loading the quote'
	        });
	      });
	    };
	
	    _this.state = {
	      loading: true,
	      error: '',
	      author: '',
	      quote: ''
	    };
	    return _this;
	  }
	
	  Quotes.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.state.loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	        'blockquote',
	        null,
	        '"' + this.state.quote + '" - ' + this.state.author
	      )
	    );
	  };
	
	  return Quotes;
	}(_react.Component);
	
	exports.default = Quotes;
	module.exports = exports['default'];

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMzEuNDkgMzEuNDkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMxLjQ5IDMxLjQ5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBzdHlsZT0iZmlsbDojMUUyMDFEOyIgZD0iTTIxLjIwNSw1LjAwN2MtMC40MjktMC40NDQtMS4xNDMtMC40NDQtMS41ODcsMGMtMC40MjksMC40MjktMC40MjksMS4xNDMsMCwxLjU3MWw4LjA0Nyw4LjA0N0gxLjExMQ0KCUMwLjQ5MiwxNC42MjYsMCwxNS4xMTgsMCwxNS43MzdjMCwwLjYxOSwwLjQ5MiwxLjEyNywxLjExMSwxLjEyN2gyNi41NTRsLTguMDQ3LDguMDMyYy0wLjQyOSwwLjQ0NC0wLjQyOSwxLjE1OSwwLDEuNTg3DQoJYzAuNDQ0LDAuNDQ0LDEuMTU5LDAuNDQ0LDEuNTg3LDBsOS45NTItOS45NTJjMC40NDQtMC40MjksMC40NDQtMS4xNDMsMC0xLjU3MUwyMS4yMDUsNS4wMDd6Ii8+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(91);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _rightArrow = __webpack_require__(666);
	
	var _rightArrow2 = _interopRequireDefault(_rightArrow);
	
	var _smile = __webpack_require__(205);
	
	var _smile2 = _interopRequireDefault(_smile);
	
	var _Quotes = __webpack_require__(55);
	
	var _Quotes2 = _interopRequireDefault(_Quotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lab = function Lab(_ref) {
	  var data = _ref.data;
	  var portfolioItems = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'main-wrapper animated fadeIn' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'my lab',
	      _react2.default.createElement(
	        'span',
	        { className: 'title-end' },
	        '_'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'subtitle' },
	      'Showcase of work I\'ve done for clients and personal projects'
	    ),
	    _react2.default.createElement(_Quotes2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'work-listing' },
	      portfolioItems.map(function (_ref2) {
	        var pItem = _ref2.node;
	        var frontmatter = pItem.frontmatter;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'portfolio-item', key: frontmatter.path },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '' + frontmatter.path },
	            _react2.default.createElement(
	              'div',
	              { className: 'portfolio-item-thumbnail' },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                sizes: frontmatter.featuredImage.childImageSharp.sizes,
	                className: 'thumbnail'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'portfolio-item-title' },
	              _react2.default.createElement(
	                'span',
	                null,
	                frontmatter.type
	              ),
	              frontmatter.title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'next-arrow' },
	              _react2.default.createElement('img', { src: _rightArrow2.default, alt: 'Phanor Coll' })
	            )
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'subtitle content' },
	      'like what you see?',
	      _react2.default.createElement('img', { src: _smile2.default, alt: 'Phanor Coll' }),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'a-animation standout', to: '/contact' },
	        'contact me'
	      ),
	      ' ',
	      'and lets bring your ideas to life.'
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Lab;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lab-js-64ae521e8a90476c3c44.js